import _ from "lodash"

export const parseCogsMapping = (label, values) => {
    // values = _.pickBy(values, (items) => items?.expenseAccount !== '' && items?.inventoryAccount !== '')

    label = _.filter(label, item => {
        return _.keys(values).includes(item?.id + '')
    })

    return label?.map(item => {
        return {
            ...item,
            account: values[item?.id]?.inventoryAccount ?? '',
            cogs: values[item?.id]?.expenseAccount ?? ''
        }
    })
}

export const parseAdvancedMapping = (label, values) => {

    if (label?.length === 0) {
        return parseOnlyValues(values)
    }

    // values = _.pickBy(values, (items) => items !== '')

    label = _.filter(label, item => {
        return _.keys(values).includes(item?.id + '')
    })

    return label?.map(item => {
        return {
            ...item,
            account: values[item?.id] ?? ""
        }
    })
}

export const parseIndividualMapping = (options, mapping) => {

    if (options?.length === 0) {
        return parseOnlyValues(mapping)
    }

    return options?.map(items => {
        return {
            id: items.id,
            label: items.name,
            account: mapping ? mapping[items?.id] ?? '' : '',
            type: items?.typeId
        }
    })
}

export const optionsParser = (options) => {
    return options?.map(items => {
        return {
            label: items?.name ?? "",
            value: items?.id ?? ""
        }
    })
}

export const checkHasValue = (value) => {
    if (!value) {
        return false
    }

    return [...new Set(_.values(value))][0] !== ''
}

export const payloadIndividualParser = (value) => {
    let obj = {}

    for (let i = 0; i < value.length; i++) {
        obj[value[i]?.id] = value[i]?.account ?? ""
    }

    return obj
}

export const payloadPoParser = (value) => {
    let obj = {}

    for (let i = 0; i < value.length; i++) {
        obj[value[i]?.id] = {
            inventoryAccount: value[i]?.account ?? "",
            expenseAccount: value[i]?.cogs ?? "",
        }
    }

    return obj
}

export const parseOnlyValues = (values) => {
    return _.keys(values ?? {})?.map(key => {
        return {
            id: key,
            name: key,
            label: key,
            account: values[key] ?? ''
        }
    })
}